/* eslint-disable */
import * as React from "react";
import { getOverrideProps } from "./utils";
import { Flex, Text, Image, Button, Divider } from "@aws-amplify/ui-react";
import AvailableInMarketplace from "../assets/AvailableInMarketplace_White_RGB.png"; // Import the image

const GeneralFooter = (props) => {
    const {  overrides, ...rest } = props;

  const newsletter = {
    container: {
      backgroundColor: "#F9F9F9",
      flexDirection: "column",
      alignItems: "center",
      padding: "0px",
      marginTop: "0px",
      fontFamily: "Arial, sans-serif",
      fontSize: "14px",
      color: "#333",
    },
    footer: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      width: "100%",
      marginTop: "30px",
      paddingBottom: "10px",
      paddingLeft: "30px",
      paddingRight: "30px",
    },
    copyright: {
      fontSize: "1.1em",
      color: "#777",
    },
    marketplaceImage: {
      marginTop: "20px", // Add spacing above the image
      width: "150px", // Adjust the width as needed
      height: "auto",
    },
  };

  return (
    <Flex
      style={newsletter.container}
      {...getOverrideProps(overrides, "NewsletterContainer")}
    >
      <Flex
        style={newsletter.footer}
        {...getOverrideProps(overrides, "NewsletterFooter")}
      >
        {/* Left-aligned content (e.g., logo or other elements) */}
        <Flex>
          {/* Add any left-aligned content here */}
        </Flex>

        {/* Right-aligned "All rights reserved" text */}
        <Flex style={{ marginLeft: "auto" }}>
          <Text
            style={newsletter.copyright}
            {...getOverrideProps(overrides, "NewsletterCopyright")}
          >
            © 2021-2025 Aitium®. All rights reserved.
          </Text>
        </Flex>
      </Flex>

      {/* Add the marketplace image at the bottom */}
      <Image
        src={AvailableInMarketplace}
        alt="Available in Marketplace"
        style={newsletter.marketplaceImage}
        {...getOverrideProps(overrides, "MarketplaceImage")}
      />
    </Flex>
  );
};

export default GeneralFooter;